import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {CallToActionBlock} from "@/pages/billing/subscription-summary/CallToActionBlock.tsx";

export const CancelSubscription = () => {
  return (
    <CallToActionBlock text="Cancel your current subscription">
      <Button as={Link} to="/billing/cancel">
        Cancel Subscription
      </Button>
    </CallToActionBlock>
  );
};
